var map = {
	"./app.json": 494,
	"./blog.json": 495,
	"./components.json": 496,
	"./conversionTable.json": 497,
	"./currency.json": 498,
	"./currencyBRL.json": 499,
	"./currencyUSD.json": 500,
	"./cxi-old.json": 501,
	"./events.json": 502,
	"./form.json": 503,
	"./glossary.json": 504,
	"./home.json": 505,
	"./iframe.json": 506,
	"./login.json": 507,
	"./logout.json": 508,
	"./matches.json": 509,
	"./menu.json": 510,
	"./news.json": 511,
	"./notifications.json": 512,
	"./oiweek.json": 513,
	"./pages.json": 514,
	"./profile.json": 515,
	"./ranking-BKP.json": 516,
	"./ranking.json": 517,
	"./register.json": 518,
	"./startup.json": 519,
	"./startupId.json": 520,
	"./support.json": 521,
	"./translation.json": 522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 493;